var _defineProperty = require("/Users/mattdriscoll/Development/tsc/lightpaper-ee-market-map-2022/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var parser = require('js-yaml');

var optionalByteOrderMark = "\\ufeff?";
var platform = typeof process !== 'undefined' ? process.platform : '';
var pattern = '^(' + optionalByteOrderMark + '(= yaml =|---)' + '$([\\s\\S]*?)' + '^(?:\\2|\\.\\.\\.)\\s*' + '$' + (platform === 'win32' ? '\\r?' : '') + '(?:\\n)?)'; // NOTE: If this pattern uses the 'g' flag the `regex` variable definition will
// need to be moved down into the functions that use it.

var regex = new RegExp(pattern, 'm');
module.exports = extractor;
module.exports.test = test;

function extractor(string, options) {
  string = string || '';
  var defaultOptions = {
    allowUnsafe: false
  };
  options = options instanceof Object ? _objectSpread({}, defaultOptions, {}, options) : defaultOptions;
  options.allowUnsafe = Boolean(options.allowUnsafe);
  var lines = string.split(/(\r?\n)/);

  if (lines[0] && /= yaml =|---/.test(lines[0])) {
    return parse(string, options.allowUnsafe);
  } else {
    return {
      attributes: {},
      body: string,
      bodyBegin: 1
    };
  }
}

function computeLocation(match, body) {
  var line = 1;
  var pos = body.indexOf('\n');
  var offset = match.index + match[0].length;

  while (pos !== -1) {
    if (pos >= offset) {
      return line;
    }

    line++;
    pos = body.indexOf('\n', pos + 1);
  }

  return line;
}

function parse(string, allowUnsafe) {
  var match = regex.exec(string);

  if (!match) {
    return {
      attributes: {},
      body: string,
      bodyBegin: 1
    };
  }

  var loader = allowUnsafe ? parser.load : parser.safeLoad;
  var yaml = match[match.length - 1].replace(/^\s+|\s+$/g, '');
  var attributes = loader(yaml) || {};
  var body = string.replace(match[0], '');
  var line = computeLocation(match, string);
  return {
    attributes: attributes,
    body: body,
    bodyBegin: line,
    frontmatter: yaml
  };
}

function test(string) {
  string = string || '';
  return regex.test(string);
}